import React from 'react';
import { Button, Content, Heading, Image } from '@wienenergiegithub/ui-next';
import styles from '@components/components/ProductRecommender/ErrorRecommender/ErrorRecommender.module.scss';
import plugDisconnected from '@components/images/misc/plug-disconnected.svg';

const ErrorRecommender = ({ onNewCheck, title, content }) => (
  <div className={styles.wrapper}>
    <div>
      <img alt="" className={styles.image} src={plugDisconnected} />
    </div>
    <Heading align="center" size="h5">
      {title || 'Es ist ein Fehler aufgetreten!'}
    </Heading>
    <Content align="center" className={styles.content} withParser>
      {content ||
        'Leider konnte Ihre Vorberechnung nicht geladen werden. Bitte versuchen Sie es später nochmal.'}
    </Content>
    <Button
      id="error-fernwaerme-weitere-addresse-pruefen"
      isElevated
      onClick={onNewCheck}
      theme="primary"
    >
      Neu laden{' '}
    </Button>
  </div>
);

export default ErrorRecommender;
